import { PricingCards } from '../components/PricingCards';
import { Reveal } from '../components/Reveal';

export function Pricing() {
  return (
    <section id="pricing" className="py-24 lg:py-32">
      <div className="mx-auto max-w-[1200px] px-6 lg:px-10">
        <Reveal>
          <p className="text-muted-foreground text-xs uppercase tracking-[0.18em]">Pricing</p>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="font-display mt-3 max-w-3xl text-4xl font-semibold tracking-tight md:text-5xl">
            Free until you ship. <span className="text-primary">Then it scales.</span>
          </h2>
        </Reveal>
        <Reveal delay={140}>
          <p className="text-muted-foreground mt-5 max-w-2xl leading-relaxed">
            No credit card to start. Upgrade in two clicks when you outgrow the Free plan —
            or talk to us if you need something custom.
          </p>
        </Reveal>

        <Reveal delay={200} className="mt-14">
          <PricingCards source="landing" />
        </Reveal>
      </div>
    </section>
  );
}
